import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { ITIconToolTip } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { ParameterValueType } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'


export interface OrderEditProductProps  {
    setOpenModal: ITLayoutTableModalOpenSetTy
    value: ParameterValueType,
    allRowData: RowData
}

const OrderEditProduct: React.FC<OrderEditProductProps> = ({ setOpenModal, allRowData }) => {
    const {t} = useTwinTranslation()
    const myOpenModal = useCallback(() => {
        setOpenModal({ allRowData, type: 'editProduct'})
    }, [setOpenModal, allRowData])
    
    if(!allRowData.ProductId){
        return null
    }
    return (
        <ITIconToolTip message={t('productInformation', 'Información producto')} id={'showProductInformation'+allRowData.id} icon={faCircleInfo} onClick={myOpenModal}></ITIconToolTip>
    )
}

export default OrderEditProduct